import type { IconProps } from './IconProps';

export const TwitterIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M12.0258 1.67285H14.1726L9.48255 7.03326L15 14.3276H10.6799L7.2962 9.9036L3.42451 14.3276H1.27646L6.29291 8.594L1 1.67285H5.4298L8.48834 5.71652L12.0258 1.67285ZM11.2724 13.0426H12.4619L4.78343 2.8903H3.50693L11.2724 13.0426Z"
      fill="currentColor"
    />
  </svg>
);
